export default __webpack_public_path__ + "static/media/shoes5.081873ad.png";